import { useState } from "react";

const useDisclosure = () => {
	const [opened, setOpened] = useState(false);

	const open = () => setOpened(true);

	const close = () => setOpened(false);

	const toggle = () => setOpened(!opened);

	return {
		opened,
		open,
		close,
		toggle,
	};
};

export default useDisclosure;
